import * as app from "./assets/js/app";

app.main();



// WEBPACK FOOTER //
// ./index.ts


// WEBPACK FOOTER //
// ./index.ts